import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import { PresentationModeIcon } from "frontend/app-header/right-header/icons";
import { useHeaderContext } from "frontend/context/header-context";
import { memo, useRef } from "react";
import styles from "./right-header.module.css";
import { SidepanelType, sidePanelType } from "state-atoms";
import { useAtom } from "jotai";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

export const PresentationModeTrigger = memo(() => {
  const { onPresentClicked, setVotingOpen } = useHeaderContext();
  const [_, setOpenedSidePanel] = useAtom(sidePanelType);
  const iconRef = useRef<HTMLDivElement>(null);
  const iconHover = useHover(iconRef);

  return (
    <HeaderActionButton
      className={styles.actionIcon}
      onClick={() => {
        onPresentClicked();
        setOpenedSidePanel(SidepanelType.none);
        setVotingOpen(false);
      }}
      ref={iconRef}
    >
      <PresentationModeIcon />
      {iconHover && (
        <Tooltip
          design="monday"
          label={"Present"}
          relativeTo={iconRef}
          side={"bottom"}
          customStyle={{ borderRadius: 3 }}
        />
      )}
    </HeaderActionButton>
  );
});

PresentationModeTrigger.displayName = "PresentationModeTrigger";
